import auth from "@/auth/index"
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    children: [
      {
        path: '/nodeManage',
        name: 'nodeManage',
        component: resolve => require(['@/views/node/index'], resolve),
        meta: {
          title: '主机管理',
          breadLevel: 0,
          icon: 'icon-node',
          auth: auth.node
        }
      }
    ]
  }
]

export default routes
